import React, { useContext } from "react";
import moment from "moment";
import { Button } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { useHistory, useLocation } from "react-router-dom";

import RefreshIcon from "@mui/icons-material/Refresh";

import AppContext from "../appContext";
import { dateFormat, logging } from "../tools";
import { useTranslation } from "react-i18next";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function EditorMessage({ lastSaved = "" }) {
  const {
    app: {
      client: {
        editable,
        writeAccess,
        lastSaved: clientLastSaved,
        lockMinutesLeft,
      },
    },
  } = useContext(AppContext);
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  /*   console.log(
    `lastSaved is ${lastSaved} and clientLastSaved is ${clientLastSaved}`
  ); 
  console.log(`editable is ${editable} and writeAccess is ${writeAccess}`);*/
  const getAlert = () => {
    if (editable === 1 && writeAccess === 0)
      return {
        message: t("access.readOnly"),
        action: null,
        severity: "info",
      };
    if (editable === 0 && writeAccess === 0)
      return {
        message: t("access.noEditRights"),
        action: null,
        severity: "info",
      };
    if (editable === 0 && writeAccess === 1)
      return {
        message: t("access.locked", { time: Number(lockMinutesLeft) + 1 }),
        action: null,
        severity: "info",
      };
    if (
      lastSaved !== "" &&
      moment(clientLastSaved, dateFormat).isAfter(
        moment(lastSaved, dateFormat)
      ) &&
      writeAccess === 1
    )
      return {
        message: t("access.newVersion"),
        action: (
          <Button
            startIcon={<RefreshIcon />}
            color="inherit"
            size="small"
            onClick={() => {
              logging("action button click");
              history.replace({
                state: { ...location.state, type: "RELOAD" },
              });
            }}
          >
            {t("access.refresh")}
          </Button>
        ),
        severity: "warning",
      };
    return null;
  };
  const alert = getAlert();
  if (alert === null) return null;
  return (
    <Alert
      severity={alert.severity}
      style={{ position: "fixed", bottom: 32, right: 32, zIndex: 2 }}
      action={alert.action}
    >
      {alert.message}
    </Alert>
  );
}
